import {ArrowSortDown20Regular, ArrowSortUp20Regular, ArrowSortDown20Filled, ArrowSortUp20Filled} from "@fluentui/react-icons";
import styles from "./IconSort.module.css";
import React from "react";

interface IconSortProps
{
    desc: boolean,    
    className?: string,
    title?: string, 
    onClick?: (e: React.MouseEvent) => void,
}

export default function IconSort({desc, className, onClick, title}: IconSortProps) {
    const icon = desc
        ? <ArrowSortDown20Filled className={className} onClick={onClick}/>
        : <ArrowSortUp20Filled className={className} onClick={onClick}/>; 
    return <div style={{height: "0"}} title={title}>
        {icon}
    </div>
}